<template>
    <div>
        <h2 class="mb-1">{{ $t("settings.teams.channels.title") }}*</h2>

        <b-form-checkbox v-model="allSelected" :indeterminate="indeterminate" @change="toggleAll">
            {{ allSelected ? $t("settings.teams.channels.deselect-all") : $t("settings.teams.channels.select-all") }}
        </b-form-checkbox>

        <validation-provider name="channels" rules="required|min:1">
            <b-form-group slot-scope="{ valid, errors }">
                <b-form-checkbox-group
                    id="channels"
                    v-model="teamData.channels"
                    :options="channels"
                    :state="errors[0] ? false : null"
                    class="ml-4"
                    stacked
                    value-field="id"
                    text-field="name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
        </validation-provider>

        <hr />
    </div>
</template>
<script>
import { BFormGroup, BFormCheckboxGroup, BFormCheckbox, BFormInvalidFeedback } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";

export default {
    components: {
        BFormGroup,
        BFormCheckbox,
        BFormCheckboxGroup,
        BFormInvalidFeedback,
        ValidationProvider,
    },
    props: {
        teamData: {
            type: Object,
            required: true,
        },
        channels: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            required,
        };
    },
    watch: {
        "teamData.channels"(newValue) {
            if (newValue.length === 0) {
                this.indeterminate = false;
                this.allSelected = false;
            } else if (newValue.length === this.channels.length) {
                this.indeterminate = false;
                this.allSelected = true;
            } else {
                this.indeterminate = true;
                this.allSelected = false;
            }
        },
    },
    methods: {
        toggleAll(checked) {
            this.teamData.channels = checked ? this.channels.map((channel) => channel.id) : [];
        },
    },
    setup(props) {
        const allSelected =
            props.channels &&
            props.teamData.channels &&
            props.channels.length > 0 &&
            props.channels.length === props.teamData.channels.length;
        const indeterminate =
            props.channels &&
            props.teamData.channels &&
            props.teamData.channels.length > 0 &&
            props.channels.length > props.teamData.channels.length;

        return {
            allSelected,
            indeterminate,
        };
    },
};
</script>
